import React, { useState } from 'react'
import PropTypes from 'prop-types'

const CopyForm = (props) => {
  const [firstGroup, setFirstGroup] = useState('')
  const [secondGroup, setSecondGroup] = useState('')
  const [thirdGroup, setThirdGroup] = useState('')
  const [fourthGroup, setFourthGroup] = useState('')
  const [fifthGroup, setFifthGroup] = useState('')

  const watchFirstGroup = (e) => {
    if (firstGroup == e.target.value) {
      resetSource('kantoku')
      setFirstGroup('')
    } else {
      singleCheckbox(e)
      setSource({ to: 'team_detail_kantoku', from: e.target.value })
      setFirstGroup(e.target.value)
    }
  }

  const watchSecondGroup = (e) => {
    if (secondGroup == e.target.value) {
      resetSource('tantou')
      setSecondGroup('')
    } else {
      singleCheckbox(e)
      setSource({ to: 'team_detail_tantou', from: e.target.value })
      setSecondGroup(e.target.value)
    }
  }

  const watchThirdGroup = (e) => {
    if (thirdGroup == e.target.value) {
      resetSource('delivery')
      setThirdGroup('')
    } else {
      singleCheckbox(e)
      setSource({ to: 'team_detail_delivery', from: e.target.value })
      setThirdGroup(e.target.value)
    }
  }

  const watchFourthGroup = (e) => {
    if (fourthGroup == e.target.value) {
      resetSource('doctor')
      setFourthGroup('')
    } else {
      singleCheckbox(e)
      setSource({ to: 'team_detail_doctor', from: e.target.value })
      setFourthGroup(e.target.value)
    }
  }

  const watchFifthGroup = (e) => {
    if (fifthGroup == e.target.value) {
      resetSource('teacher')
      setFifthGroup('')
    } else {
      singleCheckbox(e)
      setSource({ to: 'team_detail_teacher', from: e.target.value })
      setFifthGroup(e.target.value)
    }
  }

  const setSource = (args) => {
    switch(props.which_group) {
      case 'first':
        document.getElementById(`${args.to}_sei`).value = document.getElementById(`${args.from}_sei`).value
        document.getElementById(`${args.to}_mei`).value = document.getElementById(`${args.from}_mei`).value
        document.getElementById(`${args.to}_sei_kana`).value = document.getElementById(`${args.from}_sei_kana`).value
        document.getElementById(`${args.to}_mei_kana`).value = document.getElementById(`${args.from}_mei_kana`).value
        if (document.getElementById(`${args.from}_phone_number`)) {
          document.getElementById(`${args.to}_phone_number`).value = document.getElementById(`${args.from}_phone_number`).value
        }
        break
      case 'second':
        document.getElementById(`${args.to}_sei`).value = document.getElementById(`${args.from}_sei`).value
        document.getElementById(`${args.to}_mei`).value = document.getElementById(`${args.from}_mei`).value
        document.getElementById(`${args.to}_sei_kana`).value = document.getElementById(`${args.from}_sei_kana`).value
        document.getElementById(`${args.to}_mei_kana`).value = document.getElementById(`${args.from}_mei_kana`).value
        if (document.getElementById(`${args.from}_phone_number`)) {
          document.getElementById(`${args.to}_phone_number`).value = document.getElementById(`${args.from}_phone_number`).value
        }
        if (args.from == 'team_detail_daihyou') {
          document.getElementById(`${args.to}_position`).value = document.getElementById(`${args.from}_position`).value
        } else {
          document.getElementById(`${args.to}_position`).value = ''
        }
        break
      case 'third':
        document.getElementById(`${args.to}_first_zipcode`).value = document.getElementById(`${args.from}_first_zipcode`).value
        document.getElementById(`${args.to}_last_zipcode`).value = document.getElementById(`${args.from}_last_zipcode`).value
        document.getElementById(`${args.to}_prefecture_code`).value = document.getElementById(`${args.from}_prefecture_code`).value
        document.getElementById(`${args.to}_municipality_name`).value = document.getElementById(`${args.from}_municipality_name`).value
        document.getElementById(`${args.to}_municipality_code`).value = document.getElementById(`${args.from}_municipality_code`).value
        document.getElementById(`${args.to}_town_street`).value = document.getElementById(`${args.from}_town_street`).value
        if (document.getElementById(`${args.from}_building`)) {
          document.getElementById(`${args.to}_building`).value = document.getElementById(`${args.from}_building`).value
        }
        document.getElementById(`${args.to}_phone_number`).value = document.getElementById(`${args.from}_phone_number`).value
        break
      case 'fourth':
        document.getElementById(`${args.to}_sei`).value = document.getElementById(`${args.from}_sei`).value
        document.getElementById(`${args.to}_mei`).value = document.getElementById(`${args.from}_mei`).value
        document.getElementById(`${args.to}_sei_kana`).value = document.getElementById(`${args.from}_sei_kana`).value
        document.getElementById(`${args.to}_mei_kana`).value = document.getElementById(`${args.from}_mei_kana`).value
        if (args.from == 'team_detail_daihyou' || args.from == 'team_detail_tantou' ) {
          document.getElementById(`${args.to}_position`).value = document.getElementById(`${args.from}_position`).value
        } else {
          document.getElementById(`${args.to}_position`).value = ''
        }
        break
      case 'fifth':
        document.getElementById(`${args.to}_sei`).value = document.getElementById(`${args.from}_sei`).value
        document.getElementById(`${args.to}_mei`).value = document.getElementById(`${args.from}_mei`).value
        document.getElementById(`${args.to}_sei_kana`).value = document.getElementById(`${args.from}_sei_kana`).value
        document.getElementById(`${args.to}_mei_kana`).value = document.getElementById(`${args.from}_mei_kana`).value
        if (args.from == 'team_detail_tantou' ) {
          document.getElementById(`${args.to}_email`).value = document.getElementById(`${args.from}_email`).value
          document.getElementById(`${args.to}_phone_number`).value = document.getElementById(`${args.from}_phone_number`).value
        }
        break
    }
  }

  const resetSource = (arg) => {
    switch(props.which_group) {
      case 'first':
        document.getElementById(`team_detail_${arg}_sei`).value = props.team_detail[`${arg}_sei`]
        document.getElementById(`team_detail_${arg}_mei`).value = props.team_detail[`${arg}_mei`]
        document.getElementById(`team_detail_${arg}_sei_kana`).value = props.team_detail[`${arg}_sei_kana`]
        document.getElementById(`team_detail_${arg}_mei_kana`).value = props.team_detail[`${arg}_mei_kana`]
        document.getElementById(`team_detail_${arg}_phone_number`).value = props.team_detail[`${arg}_phone_number`]
        break
      case 'second':
        document.getElementById(`team_detail_${arg}_sei`).value = props.team_detail[`${arg}_sei`]
        document.getElementById(`team_detail_${arg}_mei`).value = props.team_detail[`${arg}_mei`]
        document.getElementById(`team_detail_${arg}_sei_kana`).value = props.team_detail[`${arg}_sei_kana`]
        document.getElementById(`team_detail_${arg}_mei_kana`).value = props.team_detail[`${arg}_mei_kana`]
        document.getElementById(`team_detail_${arg}_phone_number`).value = props.team_detail[`${arg}_phone_number`]
        document.getElementById(`team_detail_${arg}_position`).value = props.team_detail[`${arg}_position`]
        break
      case 'third':
        if (props.team_detail[`${arg}_zipcode`] == null) {
          document.getElementById(`team_detail_${arg}_first_zipcode`).value = ''
          document.getElementById(`team_detail_${arg}_last_zipcode`).value = ''
        } else {
          document.getElementById(`team_detail_${arg}_first_zipcode`).value = props.team_detail[`${arg}_zipcode`].slice(0, 3)
          document.getElementById(`team_detail_${arg}_last_zipcode`).value = props.team_detail[`${arg}_zipcode`].slice(3, 7)
        }
        document.getElementById(`team_detail_${arg}_prefecture_code`).value = props.team_detail[`${arg}_prefecture_code`] || ''
        document.getElementById(`team_detail_${arg}_municipality_name`).value = props.team_detail[`${arg}_municipality_name`] || ''
        document.getElementById(`team_detail_${arg}_municipality_code`).value = props.team_detail[`${arg}_municipality_code`] || ''
        document.getElementById(`team_detail_${arg}_town_street`).value = props.team_detail[`${arg}_town_street`]
        document.getElementById(`team_detail_${arg}_building`).value = props.team_detail[`${arg}_building`]
        document.getElementById(`team_detail_${arg}_phone_number`).value = props.team_detail[`${arg}_phone_number`]
        break
      case 'fourth':
        document.getElementById(`team_detail_${arg}_sei`).value = props.team_detail[`${arg}_sei`]
        document.getElementById(`team_detail_${arg}_mei`).value = props.team_detail[`${arg}_mei`]
        document.getElementById(`team_detail_${arg}_sei_kana`).value = props.team_detail[`${arg}_sei_kana`]
        document.getElementById(`team_detail_${arg}_mei_kana`).value = props.team_detail[`${arg}_mei_kana`]
        document.getElementById(`team_detail_${arg}_position`).value = props.team_detail[`${arg}_position`]
        break
      case 'fifth':
        document.getElementById(`team_detail_${arg}_sei`).value = props.team_detail[`${arg}_sei`]
        document.getElementById(`team_detail_${arg}_mei`).value = props.team_detail[`${arg}_mei`]
        document.getElementById(`team_detail_${arg}_sei_kana`).value = props.team_detail[`${arg}_sei_kana`]
        document.getElementById(`team_detail_${arg}_mei_kana`).value = props.team_detail[`${arg}_mei_kana`]
        document.getElementById(`team_detail_${arg}_email`).value = props.team_detail[`${arg}_email`]
        document.getElementById(`team_detail_${arg}_phone_number`).value = props.team_detail[`${arg}_phone_number`]
        break
    }
  }

  const singleCheckbox = (e) => {
    document.getElementsByName(e.target.name).forEach((element) => {
      element.checked = false
    })
    e.target.checked = true
  }

  switch(props.which_group) {
    case 'first':
      return (
        <div className="columns is-multiline">
          <div className="column is-2">
            <label htmlFor="first-daihyou" className="checkbox is-primary">
              <input type="checkbox" name="first_group" value='team_detail_daihyou' id="first-daihyou" onClick={watchFirstGroup} />
              <span className="item">代表者と同じ</span>
            </label>
          </div>
          {props.central_organization === 'kouyaren' && (
            <>
              <div className="column is-2">
                <label htmlFor="first-tantou" className="checkbox is-primary">
                  <input type="checkbox" name="first_group" value='team_detail_tantou' id="first-tantou" onClick={watchFirstGroup} />
                  <span className="item">担当者と同じ</span>
                </label>
              </div>
              <div className="column is-2">
                <label htmlFor="first-teacher" className="checkbox is-primary">
                  <input type="checkbox" name="first_group" value="team_detail_teacher" id="first-teacher" onClick={watchFirstGroup} />
                  <span className="item">責任教師と同じ</span>
                </label>
              </div>
            </>
          )}
        </div>
      )

    case 'second':
      return (
        <div className="columns is-multiline">
          <div className="column is-2">
            <label htmlFor="second-daihyou" className="checkbox is-primary">
              <input type="checkbox" name="second_group" value='team_detail_daihyou' id="second-daihyou" onClick={watchSecondGroup} />
              <span className="item">代表者と同じ</span>
            </label>
          </div>
          {props.central_organization !== 'kouyaren' && (
            <div className="column is-2">
              <label htmlFor="second-kantoku" className="checkbox is-primary">
                <input type="checkbox" name="second_group" value='team_detail_kantoku' id="second-kantoku" onClick={watchSecondGroup} />
                <span className="item">監督と同じ</span>
              </label>
            </div>
          )}
        </div>
      )

    case 'third': {
      const label = (organization) => {
        if (organization === 'kouyaren') return '学校住所情報と同じ';
        if (organization === 'little_senior') return '事務局長住所情報と同じ';

        return 'チーム住所情報と同じ';
      };

      return (
        <div className="columns is-multiline">
          <div className="column is-2">
            <label htmlFor="third-team-address" className="checkbox is-primary">
              <input type="checkbox" name="third_group" value='team_detail' id="third-team-address" onClick={watchThirdGroup} />
              <span className="item">{label(props.central_organization)}</span>
            </label>
          </div>
        </div>
      )
    }
    case 'fourth': {
      const getCopyTargets = (central_org) => {
        if (central_org === 'kouyaren') {
          return [
            { value: 'team_detail_daihyou', label: '代表者と同じ', id: 'fourth-daihyou' },
            { value: 'team_detail_tantou', label: '担当者と同じ', id: 'fourth-tantou' },
            { value: 'team_detail_teacher', label: '責任教師と同じ', id: 'fourth-teacher' },
            { value: 'team_detail_kantoku', label: '監督と同じ', id: 'fourth-kantoku' }
          ];
        }

        return [
          { value: 'team_detail_daihyou', label: '代表者と同じ', id: 'fourth-daihyou' },
          { value: 'team_detail_kantoku', label: '監督と同じ', id: 'fourth-kantoku' },
          { value: 'team_detail_tantou', label: '担当者と同じ', id: 'fourth-tantou' }
        ];
      };
      const copyTargets = getCopyTargets(props.central_organization);

      return (
        <div className="columns is-multiline">
          {copyTargets.map((target) => (
            <div key={target.value} className="column is-2">
              <label htmlFor={target.id} className="checkbox is-primary">
                <input type="checkbox" name="fourth_group" value={target.value} id={target.id} onClick={watchFourthGroup} />
                <span className="item">{target.label}</span>
              </label>
            </div>
          ))}
        </div>
      )
    }
    case 'fifth':
      return (
        <div className="columns is-multiline">
          <div className="column is-2">
            <label htmlFor="fifth-daihyou" className="checkbox is-primary">
              <input type="checkbox" name="fifth_group" value='team_detail_daihyou' id="fifth-daihyou" onClick={watchFifthGroup} />
              <span className="item">代表者と同じ</span>
            </label>
          </div>
          <div className="column is-2">
            <label htmlFor="fifth-tantou" className="checkbox is-primary">
              <input type="checkbox" name="fifth_group" value='team_detail_tantou' id="fifth-tantou" onClick={watchFifthGroup} />
              <span className="item">担当者と同じ</span>
            </label>
          </div>
        </div>
      )
  }
}

CopyForm.propTypes = {
  which_group: PropTypes.string,
  team_detail: PropTypes.object,
  central_organization: PropTypes.string,
};

export default CopyForm
